import React from 'react';
import {
  DataGridLayout,
  DateTimeRangeFilter,
  DESC,
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
  SearchInput,
} from 'framework/list';
import CreateContactButton from 'domain/sales/contact/list/buttons/CreateContactButton';
import ContactEmailField from 'domain/sales/contact/list/field/ContactEmailField';
import ContactLinkField from 'domain/sales/contact/shared/field/ContactLinkField';
import { AccountFilter, AccountLinkField } from 'domain/shared/account';
import EditContactButton from 'domain/sales/contact/shared/button/EditContactButton';
import useContactService, { UPDATE_CONTACT_FROM_LIST_PAGE } from 'domain/sales/contact/shared/contactService';
import { FullDateField, PhoneField, SearchResultField } from 'framework/ui/field';

const ContactsListPage = () => {
  const { search, getFilterValidationSchema } = useContactService();

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <AccountFilter label="Account Name" source="account.alias" />
        <DateTimeRangeFilter label="Created Date" source="createdAt" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List getDataMethod={search} defaultSortField="updatedAt" defaultSortOrder={DESC}>
      <ListPageLayout
        header={<ListHeader label="Contacts" icon="fa-id-card" />}
        filter={filters}
        actions={[<CreateContactButton key="create-contact" />]}
        search={<SearchInput label="contact name" />}
      >
        <DataGridLayout
          buttons={[
            <EditContactButton
              key="edit-contact"
              source="id"
              outline
              permissionToCheck={UPDATE_CONTACT_FROM_LIST_PAGE}
            />,
          ]}
        >
          <ContactLinkField
            linkText={(contact: any) => contact.getValueBySource('id')}
            label="Contact ID"
            source="id"
            idSource="id"
            isSortable
            width={120}
          />
          <SearchResultField
            value={contact => `${contact.firstName} ${contact.middleName || ''} ${contact.lastName}`}
            label="Contact name"
            source="lastName"
            isSortable
          />
          <AccountLinkField
            label="Account name"
            source="accountName"
            sortSource="account.accountName"
            idSource="accountId"
            isSortable
            isInternal={false}
          />
          <PhoneField source="phoneNumber" label="Phone" />
          <ContactEmailField source="emails" label="Email" />
          <FullDateField source="createdAt" label="Created date" isSortable />
          <FullDateField source="updatedAt" label="Last modified date" isSortable />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ContactsListPage;
